import type { AutocompleteUser } from 'models';
import { Trans } from 'react-i18next';
import { Avatar, Flex, RichTextRenderer } from 'ui';
import { Text } from 'ui/typography';

type P = {
  instructors: AutocompleteUser[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramInstructors = ({ instructors }: P) => (
  <Flex>
    <Flex className="card-content card-content--instructors" vertical>
      <Text className="card-content__title">
        <Trans>Instructors</Trans>
      </Text>
      {instructors.map((instructor) => (
        <Flex className="participant-box" key={instructor.id}>
          <Flex className="avatar-photo avatar-photo--instructors" vertical>
            <Avatar size={48} src={instructor.profilePhoto} />
          </Flex>
          <Flex className="card-content participant-box--rich-text" vertical>
            <Text className="program-instructors__name">
              {instructor.firstName} {instructor.lastName}
            </Text>
            <RichTextRenderer data={instructor.htmlDescription} />
          </Flex>
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export default ProgramInstructors;
